import React from 'react';

function ImageGallery() {
  return null;
}

export default ImageGallery;
